"use client";

import { useState, useEffect } from "react";
import {
  HStack,
  Image,
  Input,
  Link,
  Stack,
  Text,
  Box,
} from "@chakra-ui/react";
import { Field } from "../ui/field";
import { PasswordInput } from "../ui/password-input";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../Redux/Action/auth/loginAction";
import logo from "../../Images/logo.png";
import { useTheme } from "next-themes";
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from "../../Utils/Helper";
import { CommonButton } from "../ui/CommonButton";
import {CHECK_BALANCE_PARAMS } from "../../Utils/Constants"
import { useThemeContext } from "../../Context/ThemeContext";
import { ColorModeButton } from "../ui/color-mode";
export const LoginForm = () => {
  const { resolvedTheme } = useTheme();
  const { themeConfig } = useThemeContext();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const whitelabelDataFromRedux = useSelector((state) => state?.GetWhitelabel?.whitelabelDataWithID);
  const localData = getLocalStorageItem("whitelabelData");
  const groupName = whitelabelDataFromRedux?.groupName || localData?.groupName;
  const isCorporate = groupName === 'MoneyplantFX';

  const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.GetWhitelabel?.loading);
  const [logoSrc, setLogoSrc] = useState(null);

  const whitelabelData = getLocalStorageItem("whitelabelData");
    useEffect(() => {
    if (!loading) {
      const selectedLogo =
        whitelabelData && resolvedTheme === "dark"
          ? whitelabelData.logo_dark
          : whitelabelData?.logo_light;

      setLogoSrc(selectedLogo || logo);
    }
  }, [loading, resolvedTheme]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = formData;
    let hasError = false;

    if (!email) {
      setErrors((prev) => ({ ...prev, email: "Username is required" }));
      hasError = true;
    }
    if (!password) {
      setErrors((prev) => ({ ...prev, password: "Password is required" }));
      hasError = true;
    }
    if (whitelabelData !== null) {
      formData.whitelabelID = whitelabelData._id;
      formData.paramsType = CHECK_BALANCE_PARAMS
    }

    if (!hasError) {
      setIsDisabled(true);
      // Add groupName from whitelabelData to the login payload
      const loginPayload = {
        ...formData,
        groupName: whitelabelData?.groupName || ''
      };
      dispatch(
        login({
          payload: loginPayload,
          callback: (data) => {
            if (data.meta.code === 200) {
              setIsDisabled(false);
            } else {
              setIsDisabled(false);
            }
          },
        })
      );
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    const { email, password } = formData;
    if (email && password && !errors.email && !errors.password) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [formData, errors]);



  return (
    <form onSubmit={handleSubmit}>
      <Box position="absolute" top="4" right="4">
        <ColorModeButton />
      </Box>
      <Stack
        gap="4"
        align="center"
        maxW="md"
        margin="auto"
        borderRadius="2xl"
        padding="3rem"
        bg={theme.bgCard}
        boxShadow={theme.shadowElevated}
        border="1px solid"
        borderColor={theme.borderPrimary}
        transition="all 0.3s ease"
      >
        {!loading && logoSrc && (
          <Image
            width="auto"
            objectFit="contain"
            src={logoSrc}
            alt="Logo"
            mb={4}
          />
        )}
        <Field
          label="Email"
          invalid={!!errors.email}
          errorText={errors.email}
        >
          <Input
            px={2}
            name="email"
            value={formData.email}
            onChange={handleChange}
            bg={theme.inputBg}
            borderColor={theme.inputBorder}
            color={theme.inputText}
            _placeholder={{ color: theme.inputPlaceholder }}
            _focus={{ borderColor: theme.inputBorderFocus, boxShadow: `0 0 0 1px ${theme.inputBorderFocus}` }}
          />
        </Field>

        <Field
          label="Password"
          invalid={!!errors.password}
          errorText={errors.password}
        >
          <PasswordInput
            px={2}
            name="password"
            value={formData.password}
            onChange={handleChange}
            bg={theme.inputBg}
            borderColor={theme.inputBorder}
            color={theme.inputText}
            _placeholder={{ color: theme.inputPlaceholder }}
            _focus={{ borderColor: theme.inputBorderFocus, boxShadow: `0 0 0 1px ${theme.inputBorderFocus}` }}
          />
        </Field>

        <CommonButton
          text="Submit"
          type="submit"
          disabled={isDisabled}
          variant={isDisabled ? 'default' : 'gradient'}
        />
        <HStack fontSize="md">
          <Text color={theme.textSecondary}>Don't have an account?</Text>
          <Link 
            color={theme.textLink} 
            _hover={{ color: theme.textLinkHover }}
            onClick={() => navigate("/signup")}
          >
            {isCorporate ? "Corporate Signup" : "Signup"}
          </Link>
        </HStack>
        <HStack fontSize="md">
          <Link 
            color={theme.textLink} 
            _hover={{ color: theme.textLinkHover }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password
          </Link>
        </HStack>
      </Stack>
    </form>
  );
};
